import {
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LoadState } from '../types/LoadState';
import { fetchForteckningstransaktioner } from './ForteckningarClient';
import { toForteckningstransaktioner } from './lib/toForteckningstransaktioner';
import { Forteckningstransaktion } from './types/Forteckningstransaktion';

interface ForteckningstransaktionSelectorProps {
  selectedTransaktionId: string;
  setSelectedTransaktionId: (value: string) => void;
}

export const ForteckningstransaktionSelector: React.FC<
  ForteckningstransaktionSelectorProps
> = ({ selectedTransaktionId, setSelectedTransaktionId }) => {
  const [forteckningstransaktioner, setForteckningstransaktioner] = useState<
    Forteckningstransaktion[]
  >([]);
  const [loadState, setLoadState] = useState(LoadState.Loading);

  useEffect(() => {
    const loadForteckningstransaktioner = async () => {
      setLoadState(LoadState.Loading);
      const response = await fetchForteckningstransaktioner();
      if (response.success) {
        setLoadState(LoadState.Success);
        const forteckningstransaktioner = toForteckningstransaktioner(
          response.data
        );
        setSelectedTransaktionId(forteckningstransaktioner[0]?.transactionId);
        setForteckningstransaktioner(forteckningstransaktioner);
      } else {
        setLoadState(LoadState.Error);
      }
    };

    loadForteckningstransaktioner();
  }, []);

  const handleChange = (event: SelectChangeEvent) =>
    setSelectedTransaktionId(event.target.value);

  return {
    [LoadState.Idle]: <></>,
    [LoadState.Loading]: <CircularProgress />,
    [LoadState.Success]: (
      <FormControl sx={{ width: '400px' }}>
        {forteckningstransaktioner.length ? (
          <>
            <InputLabel>Förteckningstyp</InputLabel>
            <Select
              value={selectedTransaktionId}
              label="Förteckningstyp"
              size="small"
              onChange={handleChange}
            >
              {forteckningstransaktioner.map((t) => (
                <MenuItem key={t.transactionId} value={t.transactionId}>
                  {t.name}
                </MenuItem>
              ))}
            </Select>
          </>
        ) : (
          <Alert severity="warning">
            Din användare saknar rättighet att skapa förteckningar.
          </Alert>
        )}
      </FormControl>
    ),
    [LoadState.Error]: (
      <Alert severity="error">
        Något gick fel när förteckningstyper hämtades.
      </Alert>
    ),
  }[loadState];
};
